import type { Environment } from '@change-corgi/config/environments';

import { googleTagManagerContainerIds } from './data';

export function getGoogleTagManagerScript(environment: Environment): string | undefined {
	// eslint-disable-next-line security/detect-object-injection
	const googleTagManagerContainerId = googleTagManagerContainerIds[environment];
	if (!googleTagManagerContainerId) return undefined;
	const googleTagManagerScript = `
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${googleTagManagerContainerId}');
`;
	return googleTagManagerScript;
}
